import React, { useState, useEffect } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import { HashRouter, Route, Link, Switch } from 'react-router-dom';
import moment from "moment";

function MoveToBooking(props) {
    let index = props.colDef.field;
    const [day, setDay] = useState(index);

    const moveToBookings = (data, day) => {
        let clickedValue;
        let history = props.agGridReact.props.dataHistory;
        for (let item in data) {
            if (item == day) {
                clickedValue = data[item];
            }
        }
        if (clickedValue && clickedValue != 0 && history == 0) {

            let filter = props.agGridReact.props.selectedFilter;
            let id = data.id;
            let tempDateI = day.split(" ")[1] - 1;
            let todaysDate = new Date();
            let date = moment(todaysDate, "YYYY-MM-DD").add('days', tempDateI).format('YYYY-MM-DD');
            let filterProp = {
                typeFrom: "planning",
                filter_type: filter,
                booking_date: date,
            }

            filter.find(function (value, index) {
                if (value == 'branch') {
                    filterProp.booking_branch_id = data.booking_branch_id;
                }
                if (value == 'billingParty') {
                    filterProp.billing_party_id = data.billing_party_id;
                }
                if (value == 'loadType') {
                    filterProp.load_type_id = data.load_type_id;
                }
                if (value == 'vehicleType') {
                    filterProp.vehicle_type_id = data.vehicle_type_id;
                }
            });
            if (
                (filterProp.booking_branch_id != null && filterProp.booking_branch_id != undefined) ||
                (filterProp.billing_party_id != null && filterProp.billing_party_id != undefined) ||
                (filterProp.load_type_id != null && filterProp.load_type_id != undefined) ||
                (filterProp.vehicle_type_id != null && filterProp.vehicle_type_id != undefined)
            ) {
                props.agGridReact.props.passed.passed.history.push(
                    { pathname: "/booking-request", state: { filterProp } })
            }
        } else if (clickedValue && clickedValue != 0 && history == 1) {
            let filter = props.agGridReact.props.selectedFilter;
            let id = data.id;
            let tempDateI = day.split(" ")[1] - 8;
            tempDateI = tempDateI * (-1);
            let todaysDate = new Date();
            let date = moment(todaysDate, "YYYY-MM-DD").subtract('days', tempDateI).format('YYYY-MM-DD');

            let filterProp = {
                typeFrom: "planning",
                filter_type: filter,
                booking_date: date,
            }

            filter.find(function (value, index) {
                if (value == 'branch') {
                    filterProp.booking_branch_id = data.booking_branch_id;
                }
                if (value == 'billingParty') {
                    filterProp.billing_party_id = data.billing_party_id;
                }
                if (value == 'loadType') {
                    filterProp.load_type_id = data.load_type_id;
                }
                if (value == 'vehicleType') {
                    filterProp.vehicle_type_id = data.vehicle_type_id;
                }
            });

            if (
                (filterProp.booking_branch_id != null && filterProp.booking_branch_id != undefined) ||
                (filterProp.billing_party_id != null && filterProp.billing_party_id != undefined) ||
                (filterProp.load_type_id != null && filterProp.load_type_id != undefined) ||
                (filterProp.vehicle_type_id != null && filterProp.vehicle_type_id != undefined)
            ) {
                props.agGridReact.props.passed.passed.history.push(
                    { pathname: "/booking-request", state: { filterProp } })
            }
        }
    };

    return (
        <>
            <div style={{ color: props?.agGridReact?.props?.searchHistory == 0 ? "black" : "red" }}
                title={props?.value} onClick={() => moveToBookings(props?.data, day)}>{props?.data?.[day]}</div>
        </>
    );
}

export default MoveToBooking;
